import React, {useEffect} from "react";
import Grid from "@mui/material/Grid";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import AgyleButton from "../../../../components/ui/buttons/agyleButton";
import API from '../../../../app/api';
import {
    getConfig,
    getSelectedTheatre,
} from '../../../../store/reducers/booked_admissions';
import _ from "lodash";
import {Checkbox, FormControlLabel} from '@mui/material';
import config from '../../../../app/config';
import {CloseIcon} from '../../../../components/icons/agyle';
import AgyleSimpleSearchField from '../../../../components/ui/search/agyleSimpleSearchField';
import Chip from '@mui/material/Chip';

const useStyles = makeStyles((theme) => ({
    menuPaper: {
        maxHeight: 250
    },
    workstationsLabel: {
        fontSize: 12,
        width: 200
    },
    workstationsSelectedLabel: {
        width: 200,
        marginBottom: 10,
        marginTop: 10,
        textTransform: "capitalize"
    },
    workstationGroupContent: {
        margin: "0 0 25px 0"
    },
    workstationContainer: {
      marginLeft: 10,
      //  display: "flex"
     //   maxWidth: 200
    },
    stationSelectedItem: {
        margin: "14px 10px 0 10px",
        whiteSpace: "nowrap",
        padding: "5px 12px",
        border: "0.5px solid transparent",
        borderColor: "#505050",
        borderRadius: "5px",
        display: "inline-flex"
    },
    flexItem: {
        display: "flex",
        alignContent: "center",
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "stretch",
        flexWrap: "nowrap"
    },
    icon: {
        color: "#2473d6",
        marginLeft: 10,
        cursor: "pointer"
    }
}));

const WorkstationModal = (props) => {
    const initWorkstation = [];
    const {t, i18n} = useTranslation();
    const controller = new AbortController();
    const selectedTheatre = useSelector(getSelectedTheatre);
    const configDicts = useSelector(getConfig);
    const classes = useStyles();
    const [workstation, setWorkStation] = React.useState([...initWorkstation, ...props.workstations]);
    const [workstationList, setWorkStationList] = React.useState([]);
    const [searchPhrase, setSearchPhrase] = React.useState("");

    const handleDefaultCheckTrolleyAndChairs = (data) => {
        let tmp = _.cloneDeep(data);
        let selectedTheatreDefaultWorkstationsIds = [];
        if(selectedTheatre.hasOwnProperty("defaultWorkstations") && Array.isArray(selectedTheatre.defaultWorkstations)){
            selectedTheatreDefaultWorkstationsIds = selectedTheatre.defaultWorkstations;
        }
        //build by type
        let defaultWorkstationEquipmentStuff = {};
        configDicts?.workstationEquipmentType.forEach(typeItem => {
            defaultWorkstationEquipmentStuff[typeItem.code] = tmp.filter((item) => {
                if (item.type === typeItem.code) {
                    return selectedTheatreDefaultWorkstationsIds.indexOf(item.id) > -1;
                }
                return false;
            });
        });

        setWorkStation((workstation) => {
            let workstationTmp = _.cloneDeep(workstation);
            Object.keys(defaultWorkstationEquipmentStuff).forEach( eqKey => {
                workstationTmp.push(...defaultWorkstationEquipmentStuff[eqKey]);
            })
            return workstationTmp;
        })
    };

    useEffect(()=>{
        API.getWorkstations(controller.signal).then(data => {
            setWorkStationList(data);
            if (config?.mduSessionUseWorkstationDefaults && _.isEmpty(workstation)) {
                handleDefaultCheckTrolleyAndChairs(data);
            }

        }).catch(function (error) {
            // TODO: error handler !!!
            console.error(error);
        });
        return () => {
            controller.abort();
        };
    },[])

    const handleStationCheck = (event, station) => {
        if(event.target.checked) {
            setWorkStation((workstation) => {
                let workstationTmp = _.cloneDeep(workstation);
                workstationTmp.push(station)
                return workstationTmp;
            })
        } else {
            setWorkStation((workstation) => {
                let workstationTmp = _.cloneDeep(workstation);
                let index = _.findIndex(workstationTmp, {id: station.id});
                workstationTmp.splice(index,1);
                return workstationTmp;
            })
        }
    }

    const stationSelected = (station) => {
        return workstation.some((item) => item.id === station.id)
    }

    const stationHaveOperations = (station) => {
        return props.bookedSessions?.some((item) => item.workStationId === station.id)
    }

    const handleSubmit = () => {
        if(props.onSave) {
            props.onSave(workstation);
        }
    }

    return (
        <div style={{width: "100%"}}>
            <div style={{height: "500px", overflowX: "hidden", overflowY: "auto"}} className={"scroll-normal-white"}>
                <Grid container spacing={2}>
                    <Grid item xs={4} style={{borderRight: "1px solid #ACAFB3"}}>
                        <div className={classes.workstationsLabel}> WorkStations </div>
                        <div>
                            <AgyleSimpleSearchField
                                value={searchPhrase}
                                searchIconSize={"small"}
                                onChange={setSearchPhrase}
                                placeholder={"Search by Id, name"}
                            />
                        </div>
                        <div style={{height: 400, overflow: "auto"}} className={"scroll-normal-white"}>
                            {workstationList.map((station)=>{
                                if(searchPhrase && searchPhrase.length > 0){
                                    if(_.includes(station.id.toLowerCase(), searchPhrase.toLowerCase()) || _.includes(station.name.toLowerCase(), searchPhrase.toLowerCase())){
                                        return (<div><FormControlLabel
                                            control={<Checkbox onClick={(e) => handleStationCheck(e, station)}
                                                               checked={stationSelected(station)}
                                                               disabled={stationHaveOperations(station)}
                                                               inputProps={{"aria-label": "primary checkbox"}}/>}
                                            //label={station.name + " - " + typeMap[station.type]}
                                            label={station.name}
                                        />
                                        </div>)
                                    }
                                } else {
                                    return (<div><FormControlLabel
                                        control={<Checkbox onClick={(e) => handleStationCheck(e, station)}
                                                           checked={stationSelected(station)}
                                                           disabled={stationHaveOperations(station)}
                                                           inputProps={{"aria-label": "primary checkbox"}}/>}
                                        //label={station.name + " - " + typeMap[station.type]}
                                        label={station.name}
                                    />
                                    </div>)
                                }
                            })}
                        </div>
                    </Grid>

                    <Grid item xs={8}>
                        { configDicts?.workstationEquipmentType.map((typeItem) => {
                            let workstationGroup = _.filter(workstation, (wsEl) => {
                                return wsEl.type == typeItem.code
                            })
                            return (
                                <>
                                <div className={classes.workstationsSelectedLabel}>
                                    {typeItem.description}{workstationGroup.length > 1 ? "s " : " "} ({workstationGroup.length}) :
                                </div>
                                <div className={classes.workstationGroupContent}>
                                    {workstationGroup.map(wsgItem => {
                                        return (
                                            <Chip style={{margin: 2}} key={"settings-chip_" +wsgItem.name + "_" }
                                                  color={"primary"}
                                                  deleteIcon
                                                  disabled={stationHaveOperations(wsgItem)}
                                                  onDelete={(e) => handleStationCheck(e, wsgItem)} label={wsgItem.name}/>

                                        )
                                    })}
                            </div></>)
                        })}
                    </Grid>

                </Grid>
            </div>

            <div style={{display: "flex", justifyContent: "flex-end", marginTop: 10}}>
                <AgyleButton
                    onClick={handleSubmit}
                    variant="contained">
                    Submit
                </AgyleButton>
            </div>
        </div>
        )
}

export default WorkstationModal;